module.exports = __webpack_public_path__ + "static/media/paletteGenerator2.50cc289e.jpg";